import React from "react";
import { Upload } from "lucide-react";

/**
 * Dashed upload tile — used for Excel/Image uploads on RaiseEnquiry / AssignTask.
 */
export function UploadCard({ title, subtitle, Icon = Upload, tone = "emerald", onClick, accept, onChange, testid, multiple = false }) {
  const toneMap = {
    emerald: "border-emerald-300 bg-emerald-50 text-emerald-700 hover:bg-emerald-100",
    indigo:  "border-indigo-300 bg-indigo-50 text-indigo-700 hover:bg-indigo-100",
    amber:   "border-amber-300 bg-amber-50 text-amber-700 hover:bg-amber-100",
  };
  const inputId = `upload-${testid || "file"}`;
  const isFile = !!accept;
  const inner = (
    <>
      <div className={`w-12 h-12 rounded-2xl bg-white grid place-items-center shrink-0 shadow-sm`}>
        <Icon className={`w-5 h-5`} strokeWidth={2.2} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="font-bold text-slate-900 text-sm">{title}</div>
        {subtitle && <div className="text-xs text-slate-500 mt-0.5">{subtitle}</div>}
      </div>
    </>
  );
  const commonCls = `flex items-center gap-3 w-full p-4 rounded-2xl border-2 border-dashed transition-all duration-200 active:scale-[0.99] ${toneMap[tone] || toneMap.emerald}`;

  if (isFile) {
    return (
      <label htmlFor={inputId} data-testid={testid} className={`${commonCls} cursor-pointer`}>
        {inner}
        <input id={inputId} type="file" accept={accept} multiple={multiple} onChange={onChange} className="hidden" data-testid={`${testid}-input`} />
      </label>
    );
  }
  return (
    <button type="button" onClick={onClick} data-testid={testid} className={commonCls}>
      {inner}
    </button>
  );
}
